import { render, staticRenderFns } from "./sms-notice.vue?vue&type=template&id=c021e24c&scoped=true"
import script from "./sms-notice.vue?vue&type=script&lang=js"
export * from "./sms-notice.vue?vue&type=script&lang=js"
import style0 from "./sms-notice.vue?vue&type=style&index=0&id=c021e24c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c021e24c",
  null
  
)

export default component.exports